import React, { useState } from 'react'

import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material'
import format from 'date-fns/format'
import { useParams } from 'react-router-dom'

import { ConfirmModal } from 'components/_base'
import LoadingView from 'components/LoadingView'
import { DescriptionListTable } from 'components/table'
import useCampaign from 'hooks/useCampaign'
import { useCampaignBilling, useDeleteCampaignSubscription } from 'hooks/useCampaignBilling'

const BillingSummary = () => {
  const { id } = useParams()
  const { data: campaign } = useCampaign(id)
  const title = campaign?.details?.title
  const { data: billing, isLoading, error } = useCampaignBilling(id)
  const deleteSubscription = useDeleteCampaignSubscription()
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)

  const config = [
    {
      title: 'Subscription',
      render: ({ subscriptionId }: any) => (
        <a
          href={`https://dashboard.stripe.com/subscriptions/${subscriptionId}`}
          rel="noopener noreferrer"
          target="_blank">
          {subscriptionId}
        </a>
      ),
    },
    {
      title: 'Currency',
      field: 'currency',
    },
    {
      title: 'Created',
      render: ({ createdAt }: any) => format(createdAt, 'yyyy-MM-dd HH:mm:ss'),
    },
    {
      title: 'VAT tax',
      render: ({ taxPercent }: any) => `${taxPercent}%`,
    },
  ]

  const handleDeleteBtnClick = () => setDeleteConfirmOpen(true)
  const handleModalClose = () => setDeleteConfirmOpen(false)
  const handleModalConfirm = () => {
    deleteSubscription.mutate(id)
    setDeleteConfirmOpen(false)
  }

  return (
    <Card sx={{ mb: '1rem' }}>
      <CardHeader title="Subscription" />
      <CardContent>
        <LoadingView error={error ? 'Error occurred when loading billing summary data' : undefined} loading={isLoading}>
          <DescriptionListTable config={config} data={billing} />
        </LoadingView>
      </CardContent>
      <CardActions>
        <Button color="secondary" onClick={handleDeleteBtnClick} size="small">
          Delete subscription
        </Button>
      </CardActions>
      <ConfirmModal
        content={
          <>
            <p>This will remove Stripe subscription for:</p>
            <p>
              <b>
                {title} ({id})
              </b>
            </p>
            <p>This cannot be undone!</p>
          </>
        }
        onClose={handleModalClose}
        onConfirm={handleModalConfirm}
        open={deleteConfirmOpen}
        title="Are you sure you want to remove campaign subscription? "
      />
    </Card>
  )
}

export default BillingSummary
